<template>
    <div>
        <vs-button type="filled" color="danger" class="float-right text-sm mb-5" @click="clearRadio" v-if="isSelected">Clear</vs-button>
        <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(promo, index) in promoData" :key="index" :class="{'is-selected': promo.checked}">
            <template slot="no-body">
                <label class="vs-component con-vs-radio vs-radio-primary w-full p-3 py-4">
                    <input name="radio" type="radio" class="vs-radio--input" :id="promo.id" :value="promo.id" @click="addPromotion(promo)">
                    <span class="vs-radio position-relative" :class="{'bg-primary': promo.checked}">
                        <span :class="{'vs-radio--borde': !promo.checked}"></span>
                        <!-- <span class="vs-radio--borde"></span> -->
                        <span class="vs-radio--circle" style="position: relative;">
                            <!-- <transition name="list"> -->
                            <!-- <i class="vs-icon material-icons text-white rounded-full" style="position: absolute; top: 1px; left: 1px; padding: 1px">check</i> -->
                            <!-- </transition> -->
                        </span>
                        <i class="vs-icon material-icons text-white rounded-full" style="position: absolute; top: 1px; left: 1px; padding: 1px">check</i>
                    </span>
                    <span class="vs-radio--label">
                        <!-- <div class="title pl-4 font-bold text-2xl py-1">{{promo.campaign.name}}</div> -->
                        <div class="content pl-4 pb-1">{{promo.campaign.name}}</div>
                    </span>
                </label>
            </template>
        </vx-card>
        <!-- <input name="radio" id="temp-radio-promo" type="radio" hidden> -->
    </div>
</template>
<script>
export default {
    name: 'checkout-promotion',
    props:{
      popupConfigPromotion:{
        type: Object,
        required: true
      },
      promoData: {
        type: Array,
        required: true
      }
    },

    data() {
      return {
        isSelected: false
      }
    },

    watch: {
      promoData: {
        immediate: true,
        deep: true,
        handler() {
          this.checkSelectPromo();
        }
      }
    },

    methods: {
      checkSelectPromo() {
        if(this.promoData) {
          for(let i = 0; i < this.promoData.length; i++) {
            if(this.promoData[i].checked) {
              this.isSelected = true;
              return;
            }
          }
        }
        this.isSelected = false;
      },
      clearRadio(){
        this.$emit('ClearPromo');
        // this.isSelected = false;
      },
      changeStatusRadio(item) {
        for(let i = 0; i < this.promoData.length; i++) {
          if(this.promoData[i].checked) {
              // this.promoData[i].checked = false;
              this.$store.dispatch('checkin/CHANGE_STATUS_PROMOTION', this.promoData[i]);
          }
        }
        for(let i = 0; i < this.promoData.length; i++) {
          if(this.promoData[i].id == item.id) {
              // this.promoData[i].checked = true;
              if(this.promoData[i].checked != true) {
                this.$store.dispatch('checkin/CHANGE_STATUS_PROMOTION', this.promoData[i]);
              }
          }
        }
        // this.checkSelectPromo();
      },
      addPromotion(promo){
        this.changeStatusRadio(promo);
        this.$emit("AddPromotion" , promo);
      }
    }
}
</script>